import { Box } from '@mui/material';
import PublishIcon from '@mui/icons-material/Publish';
import { LoadingSkeleton, FormTitleBox } from '../../common/components';
import CouponsMailsFilters from './components/CouponsMailsFilters';
import CouponsMailsDataTable from './components/CouponsMailsDataTable';
import CouponsMailsPagination from './components/CouponsMailsPagination';
import EmailDialog from './components/EmailDialog';
import BulkSendConfirmationDialog from './components/BulkSendConfirmationDialog';
import EmailResultsDialog from './components/EmailResultsDialog';
import { useCouponsMailsTable } from './hooks/useCouponsMailsTable';

/**
 * Componente principal para envío de cupones por email
 * Refactorizado para usar TanStack Query y componentes de /common
 */
const CouponsMailsTable = () => {
  const {
    // Datos principales
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,

    // Estados de diálogos
    emailDialogOpen,
    bulkConfirmationDialogOpen,
    emailResultsDialogOpen,
    selectedEmailData,
    emailResults,

    // Estados de selección
    selectedItems,
    includeAllSubscribers,

    // Datos externos
    plans,
    groups,

    // Handlers
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleSendEmail,
    handleSelectItem,
    handleIncludeAllSubscribersChange,
    handleBulkSend,
    handleBulkSendConfirmation,
    handleCloseEmailDialog,
    handleCloseBulkConfirmationDialog,
    handleCloseEmailResultsDialog,
    handleIndividualEmailResult,
    handleSearch,
  } = useCouponsMailsTable();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <Box>
      <FormTitleBox
        title="Cupon | Impresión | Cupones por mail"
        showButton={true}
        buttonText={filter.notCancelled ? 'Enviar Seleccionados' : 'Enviar Deuda'}
        buttonIcon={PublishIcon}
        onButtonClick={handleBulkSend}
      />

      <CouponsMailsFilters
        filter={filter}
        handleFilter={handleFilter}
        includeAllSubscribers={includeAllSubscribers}
        onIncludeAllSubscribersChange={handleIncludeAllSubscribersChange}
        onSearch={handleSearch}
        plans={plans}
        groups={groups}
      />

      <CouponsMailsDataTable
        data={data}
        isLoading={isLoading}
        includeAllSubscribers={includeAllSubscribers}
        totalCount={totalCount}
        selectedItems={selectedItems}
        onSendEmail={handleSendEmail}
        onSelectItem={handleSelectItem}
        LoadingComponent={LoadingSkeleton}
      />

      <CouponsMailsPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <EmailDialog
        open={emailDialogOpen}
        onClose={handleCloseEmailDialog}
        emailData={selectedEmailData}
        plans={plans}
        onSendResult={handleIndividualEmailResult}
        isDebt={!filter.notCancelled}
        cuotaPura={filter.cuotaPura}
      />

      <BulkSendConfirmationDialog
        open={bulkConfirmationDialogOpen}
        selectedItems={includeAllSubscribers ? data : selectedItems}
        onClose={handleCloseBulkConfirmationDialog}
        onConfirm={handleBulkSendConfirmation}
        plans={plans}
        isDebt={!filter.notCancelled}
        cuotaPura={filter.cuotaPura}
      />

      <EmailResultsDialog
        open={emailResultsDialogOpen}
        onClose={handleCloseEmailResultsDialog}
        results={emailResults}
      />
    </Box>
  );
};

export default CouponsMailsTable;
